"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logout = void 0;
const fetchClient_1 = require("../../../utils/misc/fetchClient");
const logout = (fcmToken) => __awaiter(void 0, void 0, void 0, function* () {
    const body = fcmToken
        ? {
            GulpinRegister: {
                token: decodeURIComponent(fcmToken),
                channel: "firebase",
                data_only: true,
            },
        }
        : {};
    // body will be follow ILogout type when send firebase token
    const url = `auths/logout`;
    yield (0, fetchClient_1.fetchAtClientSide)({ url, body, method: "POST" }).catch((e) => {
        console.warn("Logout Api Error", e.message);
    });
});
exports.logout = logout;
